import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { FiCommentsSettingsComponent } from './fi-comments-settings.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, FormsModule, MatRadioModule, FiAppTextSharedModule],
    declarations: [FiCommentsSettingsComponent],
    exports: [FiCommentsSettingsComponent],
})
export class FiCommentsSettingsModule {}
